module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/big-a-071f0c3d25f4a74145674a28757a3ac5.png";